import { useSystemConfig } from "../hooks/useSystemConfig";

const startUrl = () => `${import.meta.env.VITE_API_URL ?? ""}/api/auth/linkedin/start`;

export const LinkedInBanner = () => {
  const { data } = useSystemConfig();
  if (data?.linkedinConnected !== false) return null;
  return (
    <div className="bg-red-600 text-white px-6 py-3 text-sm flex justify-between items-center">
      <span>{data.bannerMessage ?? "Reconecte o LinkedIn"}</span>
      <button
        type="button"
        onClick={() => window.location.assign(startUrl())}
        className="bg-white text-red-600 px-3 py-1 rounded text-xs font-semibold"
      >
        Reconectar
      </button>
    </div>
  );
};
